import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { NewClientsApiService } from 'features/new-clients/api/new-clients-api.service';
import { queryClient } from 'providers';

import { NewClientsQueryKeys } from './query-keys';

const { createCity } = NewClientsApiService();

export const useCreateCity = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return createCity(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: NewClientsQueryKeys.all,
        });
        if (data?.rs == 1) {
          message.success(data?.rm);
        }
      },
    },
  );
};
